import React, { useState } from 'react'
import Icons from '../icons/Icons'

const CollapsableText = ({ collapsed = true, title = '', children }) => {
  
  const [ isCollapsed, setIsCollapsed ] = useState( collapsed ) 
  const colorStatus = isCollapsed ? 'msync-active-color' : 'msync-inactive-color'

  return (
    <div className={`msync-collapsable-text ${colorStatus}`}>
      <button 
        className="msync-collapsable-text-header"
        onClick={ () => setIsCollapsed( ! isCollapsed ) }
      >
          <span className='msync-collapsable-text-header-title'>{ title }</span>
          <div className='msync-collapse-arrow'>
            {
              isCollapsed ? (
                <Icons type='arrow-up' />
              ) : (
                <Icons type='arrow-down' />
              )
            }
          </div>
      </button>
      {
        isCollapsed && ( 
        <div className="msync-collapsable-text-body">
          { children }
        </div> )
      }
    </div>
  )
}

export default CollapsableText
